import React from 'react'
import FilterTag from './FilterTag'
import { useStore } from '../Store/useStore'

const Filters = ({ className }) => {
    const isFilterLogicOr = useStore((state) => state.isFilterLogicOr)
    const availableFilters = useStore((state) => state.availableFilters)()
    const initiallyAvailableFilters = useStore((state) => state.initiallyAvailableFilters)()
    const activeFilterTagUids = useStore((state) => state.activeFilterTagUids)
    const currentSearchTerm = useStore((state) => state.currentSearchTerm)
    const resetFilterState = useStore((state) => state.resetFilterState)
    const translations = useStore((state) => state.translations)

    const getResetFilter = () => {
        if (activeFilterTagUids.length <= 0 && currentSearchTerm === '') {
            return null
        }

        return (
            <div className="journal-list__filter-group--reset">
                <a className="journal-list__filter-reset" onClick={() => resetFilterState()}>
                    <span aria-hidden="true">{translations.reset}</span>
                </a>
            </div>
        )
    }

    const getAvailableFilters = () => {
        if (isFilterLogicOr && currentSearchTerm === '') {
            return initiallyAvailableFilters
        } else {
            return availableFilters
        }
    }

    return (
        <div className="journal-list__filter-list">
            <div className={className}>
                {getAvailableFilters().map((category, categoryIndex) => (
                    <div
                        className={
                            'journal-list__filter-group journal-list__filter-group--' + category.name.toLowerCase()
                        }
                        key={categoryIndex}
                    >
                        <div className="journal-list__filter-group--header">{category.name}</div>
                        {category.tags.map((filter) => (
                            <FilterTag filter={filter} key={filter.uid} />
                        ))}
                    </div>
                ))}
                {getResetFilter()}
            </div>
        </div>
    )
}

export default Filters
